"use strict";

window.__eventUI = (event) => {

	const templates = {
		'checkoutButton_quantity': $.templates('#template-checkoutButton-quantity'),
		'checkoutButton_noQuantity': $.templates('#template-checkoutButton-noQuantity')
	}

	const setupCheckoutButton = ($btn) => {

		$btn.on('click', () => {
			if ($btn.hasClass('disabled') || !isCheckoutValid()) {
				return;
			}

			const currentText = $btn.text();
			const selectedAccessType = $("#accessTypeSelection").val();

			$btn.addClass('disabled');
			$btn.text("Processing...");

			let data = {
				event: event._id,
				availabilityId: $('#timeSelector option:selected').data('availabilityId'),
			};

			if (selectedAccessType === "physical") {
				data = {
					...data,
					fatherAttending: event.hasFathersDiscount && $('#fatherAttendingOption option:selected').val() === 'yes',
					quantity: $('#quantity').val() || 1,
					childrenCount: $('#childrenCount').val() || 0,
					youngChildrenCount: $('#youngChildrenCount').val() || 0
				}
			} else if (selectedAccessType === 'virtual') {
				data = {
                    ...data,
					virtualReservation: true
				}
			}

			if ($("#howManyAttending").length === 1) {
				data.howManyAttending = $("#howManyAttending").val();
			}

			// send the POST request

			$.ajax({
				method:'POST',
				url:'/event/createReservation',
				data,

				success: (data) => {

					if (data.error) {
						$btn.text(currentText);
						updateCheckoutButtonState();
						alert(data.message);

						return;
					} else {
						window.location = data.checkoutURL;
					}
				}
			})
		})
	}

	const isCheckoutValid = () => {

		const $selectedTime = $('#timeSelector').find('option:selected');


		if (!$selectedTime.val()) {
			return false;
		}

		// make sure there's capacity for this
		const foundTime = event.availableDates.find(date => date._id === $selectedTime.data('availabilityId'));

		if (!foundTime) {
			return false;
		}

		if (event.hasFathersDiscount) {
			if ($("#fatherAttendingOption option:selected").data('isDefault')) {
				return false;
			}
		}

		return true;
	};

	const updateCheckoutButtonState = () => {
		if (isCheckoutValid()) {
			$('.addToCart').removeClass('disabled');
		} else {
			$('.addToCart').addClass('disabled');
		}
	};


	$('select.form-control').on('change', function() {
		if (event.pricePerLabel !== "person") {
			return;
		}

		const adults = parseInt($("#quantity").val());
		const children = parseInt($("#childrenCount").val());
		const youngChildren = parseInt($("#youngChildrenCount").val());
		const total = adults + children + youngChildren;
		let childrenLabel = "";
		let youngChildrenLabel = "";

		let adultTotal = adults * event.price;
		let childrenTotal = children * (event.childrensPrice || 0);
		let youngChildrenTotal = youngChildren * (event.youngChildrensPrice || 0);

		let grandTotal = (adultTotal + childrenTotal + youngChildrenTotal)/100;
		let grandTotalLabel = `$${grandTotal.toFixed(2)}`;


		if (children > 0) {
			childrenLabel = ` and ${children} child${children > 1 ? "ren" : ""}`;
		}

		if (youngChildren > 0) {
			youngChildrenLabel = ` and ${youngChildren} young child${youngChildren > 1 ? "ren" : ""}`;
		}

		if (total > 1) {
			$('.btn.addToCart').text('Buy Tickets');
		} else {
			$('.btn.addToCart').text('Buy Ticket');
		}

		$('.reservationTotalNotice').html(`<b>Note:</b> This purchase will create a reservation for ${adults} adult${adults > 1 ? "s" : ""}${childrenLabel}${youngChildrenLabel}<br><br><strong>Total:</strong> ${grandTotalLabel}`).fadeIn(333);
	}).trigger('change');

	// If the date changes, show the available times for that day.
	$("#dateSelector").on("change", function() {
		const $timeSelector = $("#timeSelector");
		const chosenTime = $(this).find("option:selected").val();
		const populateTimes = event.localizedDates.filter(x => x.condensed === chosenTime && new Date(x.original) > new Date());

		$timeSelector.empty();
		$timeSelector.append(`<option value="">Select a time</option>`);

		populateTimes.forEach(x => {
			const $option = $(`<option data-availability-id="${x._id}" value="${x.time}">${x.time}</option>`);

			if (x.admissionPurchased >= x.maxCapacity) {
				$option.prop("disabled", true);
				$option.css("color", "red");
				$option.css('text-decoration', 'line-through');
			}

			$timeSelector.append($option);
		});

		if (populateTimes.length === 1) {
			$timeSelector.val(populateTimes[0].time)
		}
		let anyNonSingletons = populateTimes.filter(x => x.maxCapacity > 1).length > 0;
		let $button;

		if (false && anyNonSingletons) {
			$button = $(templates.checkoutButton_quantity.render({}));
			$('.addCartGroup').addClass('input-group');
		} else {
			$button = $(templates.checkoutButton_noQuantity.render({}));
		}

		setupCheckoutButton($button);

		// reset checkout button
		$('.addCartGroup').html($button);

		if (!$timeSelector.val())
			$('.addCartGroup').find('.addToCart').addClass('disabled');

	}).trigger("change");

	$("#timeSelector").on("change", function() {
		updateCheckoutButtonState();
	});

	$("#accessTypeSelection").on("change", function() {
		const $this = $(this);
		const $selection = $this.find("option:selected");
		const selectedAccessType = $selection.val();

		const virtualPrice = event.virtualPrice || 0;
		const virtualPriceLabel = '$' + (virtualPrice/100).toFixed(2);

		$('.accessTypeSection').hide();
		$(`.accessTypeSection[data-access-type="${selectedAccessType}"]`).show()

		if (selectedAccessType === "virtual") {
			$(".venueInformation").hide();

			$('.priceLabel').text(virtualPriceLabel +" / group")

			$('.reservationTotalNotice').html(`<b>Note:</b> This purchase will create a streaming reservation for your family or group. You will receive an email with access instructions when the event gets closer.<br><br><strong>Total:</strong> ${virtualPriceLabel}`).fadeIn(333);
		}

		if (selectedAccessType === 'physical') {
			$('.venueInformation').show();

			$('.priceLabel').text(`$${(event.price/100).toFixed(2)} / ${event.pricePerLabel}`)
		}
	});

	$("#fatherAttendingOption").on("change", function() {
		let $selection = $(this).find("option:selected");

		if ($selection.val() === "yes") {
			$(".listPrice").text('$' + (event.fathersDiscountPrice / 100).toFixed(2));
		} else {
			$(".listPrice").text('$' + (event.price / 100).toFixed(2));
		}

		updateCheckoutButtonState();
	});

	setTimeout(() => $('select').trigger('change'), 50);
};
